// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Login from './pages/auth/login';
import Layout from "./pages/layout/layout";
import Home from "./compnenets/home";
import Login from "./pages/auth/login";
import "./App.css";
import Dashboard from "./pages/dashboard/dashboard";
import MyProjects from "./pages/my-projects/my-projects";
import Employees from "./pages/employees/employees";
import EmployeeForm from "./pages/employees/employee_form";
import RolePermissions from "./pages/RolePermissions/role_permissions";
// import ForgotPassword from './pages/auth/forgot-password.js';
// import PasswordVerify from './pages/auth/password-verify.js';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Role from "./pages/RolePermissions/role";

const App = () => {
  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          {/* <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-verify" element={<PasswordVerify />} /> */}
          <Route path="login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="employees" element={<Employees />} />
            <Route path="employee_form" element={<EmployeeForm />} />
            <Route path="role_permissions" element={<RolePermissions />} />
            <Route path="role" element={<Role />} />
            {/* <Route path="role" element={<Role />} /> */}
            <Route path="my-projects" element={<MyProjects />} />
            <Route path="project-allocation" element={<Dashboard />} />
            <Route path="portfolio" element={<Dashboard />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default App;
